// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "startpage-be63061f/chunk-" + "cd7cbe0d04454383" + ".js";
};